module.exports = __webpack_public_path__ + "static/img/jianzhu04.5834839.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu04.png
// module id = dt9B
// module chunks = 12